var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2920",
    "data-name": "Rectangle 2920",
    width: 8,
    height: 4,
    fill: "#707070"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14205",
    "data-name": "Group 14205",
    transform: "translate(-1759 -374)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1759 374)",
    fill: "#ababab",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13378",
    "data-name": "Group 13378",
    transform: "translate(1763 379.998)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12947",
    "data-name": "Path 12947",
    d: "M7.358.1,4,3.18.641.1A.4.4,0,0,0,.107.1L.094.114A.315.315,0,0,0,.106.574L3.733,3.9a.4.4,0,0,0,.535,0L7.892.575A.323.323,0,0,0,8,.333.318.318,0,0,0,7.893.1a.4.4,0,0,0-.535,0",
    transform: "translate(0 0)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDownArrow);
export default __webpack_public_path__ + "static/media/greyDownArrow.ca722e08de1631c86b5b6786854bcb3d.svg";
export { ForwardRef as ReactComponent };